import {
  WORK_ORDER_STATUSES_DISPLAY,
  WORK_ORDER_STATUS_COLORS,
} from "@miplatform/constants";
import { WorkOrderStatus } from "@miplatform/types";
import { useTheme } from "@mui/material";
import { StatusDisplayChip } from "../StatusDisplayChip/StatusDisplayChip";

export const WorkOrderStatusDisplayChip = ({
  status,
}: WorkOrderStatusDisplayChipProps) => {
  const theme = useTheme();
  const statusName = WORK_ORDER_STATUSES_DISPLAY[status] ?? "Unknown";
  const statusColor =
    WORK_ORDER_STATUS_COLORS[status] ?? theme.palette.grey.medium;

  return (
    <StatusDisplayChip statusName={statusName} statusColor={statusColor} />
  );
};

interface WorkOrderStatusDisplayChipProps {
  status: WorkOrderStatus;
}
